import { render, staticRenderFns } from "./OrderTagKeysList.vue?vue&type=template&id=799d5ab2&"
import script from "./OrderTagKeysList.vue?vue&type=script&lang=js&"
export * from "./OrderTagKeysList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports